/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutTrackingListEntryLeadAllOfAssignmentsInner
 */
export interface CarveOutTrackingListEntryLeadAllOfAssignmentsInner {
    /**
     * 
     * @type {string}
     * @memberof CarveOutTrackingListEntryLeadAllOfAssignmentsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOutTrackingListEntryLeadAllOfAssignmentsInner
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOutTrackingListEntryLeadAllOfAssignmentsInner
     */
    role: CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum;
}


/**
 * @export
 */
export const CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON'
} as const;
export type CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum = typeof CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum[keyof typeof CarveOutTrackingListEntryLeadAllOfAssignmentsInnerRoleEnum];


/**
 * Check if a given object implements the CarveOutTrackingListEntryLeadAllOfAssignmentsInner interface.
 */
export function instanceOfCarveOutTrackingListEntryLeadAllOfAssignmentsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSON(json: any): CarveOutTrackingListEntryLeadAllOfAssignmentsInner {
    return CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSONTyped(json, false);
}

export function CarveOutTrackingListEntryLeadAllOfAssignmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingListEntryLeadAllOfAssignmentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_id': json['user_id'],
        'role': json['role'],
    };
}

export function CarveOutTrackingListEntryLeadAllOfAssignmentsInnerToJSON(value?: CarveOutTrackingListEntryLeadAllOfAssignmentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'role': value.role,
    };
}

